import React from "react";
import type { RouteObject } from "react-router-dom";

import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VSL from "../pages/vsl/page";
import MerciRDV from "../pages/merci-rdv/page";
import MentionsLegales from "../pages/mentions-legales/page";
import PolitiqueConfidentialite from "../pages/politique-de-confidentialite/page";
import CGV from "../pages/cgv/page";
import Optin from "../pages/optin/page";
import APropos from "../pages/a-propos/page";
import Methode from "../pages/methode/page";
import RdvIClosed from "../pages/rdv-iclosed/page";
import LP from "../pages/lp/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <LP />,
  },
  {
    path: "/merci",
    element: <VSL />,
  },
  {
    path: "/merci-rdv",
    element: <MerciRDV />,
  },
  {
    path: "/mentions-legales",
    element: <MentionsLegales />,
  },
  {
    path: "/politique-de-confidentialite",
    element: <PolitiqueConfidentialite />,
  },
  {
    path: "/cgv",
    element: <CGV />,
  },
  {
    path: "/optin",
    element: <Optin />,
  },
  {
    path: "/a-propos",
    element: <APropos />,
  },
  {
    path: "/methode",
    element: <Methode />,
  },
  {
    path: "/rdv-iclosed",
    element: <RdvIClosed />,
  },
  {
    path: "/lp",
    element: <Home />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
